import * as React from 'react';
import DefaultIcon from './DefaultIcon';
export default (props) => (React.createElement(DefaultIcon, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M200 856V756h160l120-360H320V296h400v100H580L460 756h140v100H200Z" })));
